import { ROUTER_PATHS } from "@/shared";
import { useGetPreventaPymesById } from "@/shared/actions/erp/preventa_pymes/preventa_pymes.action";
import { LoaderComponent } from "@/shared/components/ui";
import { Navigate, useParams } from "react-router-dom";
import SaveSolicitudClientePymes from "../../shared/componente/save_solicitud_cliente_pymes/SaveSolicitudClientePymes";


export default function SolicitudContratoClientePymes() {

  const routerBack = ROUTER_PATHS.clientes.clientesPymesNav;

  const { id } = useParams();

  const {
    data: dataPreventa,
    isLoading
  } = useGetPreventaPymesById(id!)

  if (isLoading)
    return <LoaderComponent />

  if (!dataPreventa)
    return <Navigate to={routerBack} />


  return (
    <SaveSolicitudClientePymes
      dataPreventa={dataPreventa}
    />
  )

}